import { QuotedTabsPanel } from 'components/secondaryMarket/live/sidePanel/quoted/QuotedTabsPanel';
import { connect } from 'react-redux';
import type { FormOwnProps } from 'shared/connect/connect';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import type { LiveGreeks } from 'state/secondaryMarket/live/quote/liveQuote.model';
import {
  getLiveQuoteFormattedAccruedInterest,
  getLiveQuoteGreeks,
  getLiveQuotePriceType,
  getLiveQuoteQuoteId,
} from 'state/secondaryMarket/live/quote/liveQuote.selector';
import { liveReferentialSelectors } from 'state/secondaryMarket/live/referential/liveReferential.selector';
import type {
  SecondaryPriceType,
  SecondaryQuotationType,
} from 'state/secondaryMarket/productSearch/productSearch.model';
import { getUserPreferencesGreeksPrecision } from 'state/selectors';
import type { AppState } from 'state/state.model';

export type QuotedTabsPanelStateProps = {
  quoteId?: string;
  priceType: SecondaryPriceType;
  priceCurrency: string;
  greeks: LiveGreeks[];
  greeksPrecision: number;
  accruedInterest?: number;
  quotationType?: SecondaryQuotationType;
};

type QuotedTabsPanelDispatchProps = {};

type QuotedTabsPanelOwnProps = FormOwnProps;

export type QuotedTabsPanelProps = QuotedTabsPanelDispatchProps & QuotedTabsPanelOwnProps & QuotedTabsPanelStateProps;

const mapStateToProps = (state: AppState, { formId }: QuotedTabsPanelOwnProps): QuotedTabsPanelStateProps => {
  return {
    accruedInterest: getLiveQuoteFormattedAccruedInterest(state, formId),
    priceType: (getLiveQuotePriceType(state, formId) ?? liveReferentialSelectors.getPriceType(state, formId))!,
    priceCurrency: liveReferentialSelectors.getCurrency(state, formId)!,
    quoteId: getLiveQuoteQuoteId(state, formId)!,
    greeks: getLiveQuoteGreeks(state, formId),
    greeksPrecision: getUserPreferencesGreeksPrecision(state) ?? 3,
    quotationType: liveSelectors.getQuotationType(state, formId!),
  };
};

export const connectQuotedTabsPanel = connect(mapStateToProps);

export const ConnectedQuotedTabsPanel = connectQuotedTabsPanel(QuotedTabsPanel);
